import { render, staticRenderFns } from "./ContactConfirmations.vue?vue&type=template&id=080b8aed"
import script from "./ContactConfirmations.vue?vue&type=script&lang=js"
export * from "./ContactConfirmations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports